import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';

export const MobileCarousel = ({ children, className = '' }) => {
  const items = Array.isArray(children) ? children : [children];
  
  return (
    <>
      {/* Desktop Grid */}
      <div className={`hidden md:grid ${className}`}>
        {children}
      </div>
      
      {/* Mobile Carousel */}
      <div className="md:hidden">
        <Carousel className="w-full">
          <CarouselContent>
            {items.map((item, index) => (
              <CarouselItem key={index}>
                {item}
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2" />
          <CarouselNext className="right-2" />
        </Carousel>
      </div>
    </>
  );
};